import { IUIType, IAnswerOption, IQuestionPart } from "../../../api/private/learn-engine-api/learn-engine-api.interface";

export enum ImageLoadedState {
    Success = 'success',
    Loading = 'loading',
    Failed = 'failed',
}

export interface ISlAnswerProps {
    uiType?: IUIType;
    options: IAnswerOption[];
    questionParts?: IQuestionPart[];
    onChange: (options: IAnswerOption[]) => void;
    isValid: (valid: boolean) => void;
    disabled?: boolean;
    instructions?: string;
}
